import anime from "animejs";
export default function() {
    const body = document.body;
    const links = document.querySelectorAll('.menu-item');
    let ss = window.innerWidth;
    //console.log(ss)
    console.log(ss)
    if(ss > 992)  {
        links.forEach((link) => {
            if(link.classList.contains('menu-item-has-children')) {
                link.addEventListener('mouseover', function() {
                body.classList.add('menu-open');
                console.log('menu open');
                });
                link.addEventListener('mouseout', function() {
                body.classList.remove('menu-open');
                console.log('menu close');
                });
            }
        })
    }
}